
import React from "react";
import fields from "../../json/EmailSettingFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const EmailConfigForm = ({ values = "0", errors, handleChange, handleSubmit, loading, title = "Email Config Setting", canUpdate = false }) => {
  const { EmailConfigFormData } = fields;
  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {EmailConfigFormData.map((field) => {
        if (field.name === "email_config_id") { return null }
        if (field.type === "switch") {
          return (
            <Switch
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      {canUpdate && (
        <FormSubmitButton
          label={`Update`}
          loading={loading}
          colSize="col-12"
          align="end"
        />
      )}
    </PageBody>
  );
};

export default EmailConfigForm;